module.exports = __webpack_public_path__ + "img/logo-monetizze-menu.bee9b8dd.svg";